export const ALL_ROUTE_CHAR = '*';
export const PAGE_INDEX_DEFAULT = 0;
export const PAGE_SIZE_DEFAULT = 10;
export const PAGE_SIZE_FULL_ITEM = 9999;

export const AppRouteConst = {
  HOME: '/',
  DASHBOARD: '/',
  TRANSACTION: '/trans',
  STORE: '/store',
  COMPANY: '/company',
  BOOTH: '/booth',

  THEME: {
    LIST: '/theme',
    CREATE: '/theme/c',
    EDIT: '/theme/:id',
  },
  THEME_CATEGORY: '/theme-category',
  THEME_TEMPLATE: {
    LIST: '/theme-template',
    CREATE: '/theme-template/c',
    EDIT: '/theme-template/:id',
  },
  LAYOUT_TEMPLATE: {
    LIST: '/layout-template',
    CREATE: '/layout-template/c',
    EDIT: '/layout-template/:id',
  },

  STICKER: {
    LIST: '/sticker',
    CREATE: '/sticker/c',
    EDIT: '/sticker/:id',
  },
  STICKER_CATEGORY: '/sticker-category',
  STICKER_TEMPLATE: {
    LIST: '/sticker-template',
    CREATE: '/sticker-template/c',
    EDIT: '/sticker-template/:id',
  },

  PROMOTION_CAMPAIGN: '/promotion-campaign',
  VOUCHER: {
    LIST: '/voucher',
    CREATE: '/voucher/c',
    EDIT: '/voucher/:id',
  },
  REPORT: {
    LIST: '/report',
    REPORT_DASHBOARD: '/report',
    REPORT_BY_SHOOTING_COUNT: '/report/shooting-count',
    REPORT_SHOOTING_DURATION: '/report/shooting-duration',
    REPORT_DEPOSIT_LOG: '/report/deposit-log',
    REPORT_ERROR_BOOTH: '/report/error-booth',
    REPORT_CUSTOMER_FEEDBACK: '/report/customer-feedback',
  },
  FEEDBACK: {
    LIST: '/feedback-criterias',
  },
  LOCATION: '/location',
  USER: '/user',
  PROFILE: {
    PREFIX: '/profile',
    MY_PROFILE: '/profile/my-profile',
    CHANGE_PASSWORD: '/profile/change-password',
    DETAIL: '/profile/d/:id',
    CHANGE_PINCODE: '/profile/change-pincode',
  },
  SETTING: {
    LIST: '/setting',
    SETTING_CAPTURE_POSITION: {
      LIST: '/setting/capture-position',
      CREATE: '/setting/capture-position/c',
      EDIT: '/setting/capture-position/:id',
    },
    SETTING_CAPTURE_POSITION_TEMPLATE: {
      LIST: '/setting/capture-position-template',
      CREATE: '/setting/capture-position-template/c',
      EDIT: '/setting/capture-position-template/:id',
    },
    SETTING_PHOTO_ALBUM: {
      LIST: '/setting/photo-album',
      CREATE: '/setting/photo-album/c',
      EDIT: '/setting/photo-album/:id',
    },
    SETTING_UI_TEMPLATE_BOOTH: {
      LIST: '/setting/ui-template-booth',
      CREATE: '/setting/ui-template-booth/c',
      EDIT: '/setting/ui-template-booth/:id',
    },
    SETTING_BOOTH_BACKGROUND: {
      LIST: '/setting/booth-background',
      CREATE: '/setting/booth-background/c',
      EDIT: '/setting/booth-background/:id',
    },
    SETTING_BOOTH_VERSION: {
      LIST: '/setting/booth-version',
      CREATE: '/setting/booth-version/c',
      EDIT: '/setting/booth-version/:id',
    },
    SETTING_BOOTH_BACKGROUND_CATEGORY: '/setting/booth-background-category',
    SETTING_BOOTH_BACKGROUND_TEMPLATE: {
      LIST: '/setting/booth-background-template',
      CREATE: '/setting/booth-background-template/c',
      EDIT: '/setting/booth-background-template/:id',
    },
    SETTING_NEWS: {
      LIST: '/setting/news',
      CREATE: '/setting/news/c',
      EDIT: '/setting/news/:id',
    },
    SETTING_FAQ: {
      LIST: '/setting/faq',
      CREATE: '/setting/faq/c',
      EDIT: '/setting/faq/:id',
    },
    SETTING_MEMBER: {
      LIST: '/setting/member',
      CREATE: '/setting/member/c',
      EDIT: '/setting/member/:id',
    },
    SETTING_MESSAGE_TEMPLATE: {
      LIST: '/setting/message-template',
      CREATE: '/setting/message-template/c',
      EDIT: '/setting/message-template/:id',
    },

    // setting photo filter
    SETTING_PHOTO_FILTER: {
      LIST: '/setting/photo-filter',
      CREATE: '/setting/photo-filter/c',
      EDIT: '/setting/photo-filter/:id',
    },
    SETTING_PHOTO_FILTER_TEMPLATE: {
      LIST: '/setting/photo-filter-template',
      CREATE: '/setting/photo-filter-template/c',
      EDIT: '/setting/photo-filter-template/:id',
    },

    // advertisement
    SETTING_ADVERTISEMENT: {
      LIST: '/setting/advertisement',
      CREATE: '/setting/advertisement/c',
      EDIT: '/setting/advertisement/:id',
    },
    // advertisement
    SETTING_ADVERTISEMENT_PLAYLIST: {
      LIST: '/setting/advertisement-playlist',
      CREATE: '/setting/advertisement-playlist/c',
      EDIT: '/setting/advertisement-playlist/:id',
    },
    SETTING_LANG: {
      LIST: '/setting/lang',
      CREATE: '/setting/lang/c',
      EDIT: '/setting/lang/:id',
    },
    SETTING_CURRENCY: {
      LIST: '/setting/currency',
      CREATE: '/setting/currency/c',
      EDIT: '/setting/currency/:id',
    },
  },
  GUIDE: '/guide',
  PAGE_403: '/403',
};

export const AuthRouteConst = {
  AUTH: '/auth',
  LOGIN: '/auth/login',
};

export const QUERY_STRING = {
  SEARCH_TEXT: 's',
  ID: 'id',
  DATE: 'd',
  START_DATE: 'sd',
  END_DATE: 'ed',
  TRANSACTION: 't',
  PAGE: 'p',
  PAGE_SIZE: 'ps',
  ACTIVE: 'act',
  STATUS: 'st',
  PAYMENT_METHOD: 'pm',
  CAPTURE_MODE: 'cm',
  DEPOSIT_TYPE: 'dt',
  SELECT_SEARCH_ID: 'ssid',
  SELECT_SEARCH_NAME: 'ssn',
  LAYOUT_ID: 'lid',
  LAYOUT_NAME: 'ln',
  COMPANY_ID: 'comid',
  COMPANY_NAME: 'comn',
  STORE_ID: 'storeid',
  STORE_NAME: 'storen',
  ROLE_ID: 'roleid',
  ROLE_NAME: 'rolen',
  REFUND_AMOUNT: 'ra',
  FROM_TIME: 'ft',
  TO_TIME: 'tt',
  MODULE: 'module',
  ACTION: 'action',
  CRITERIA_TYPE: 'ct',
  CUSTOMER_FEEDBACK: 'cf',
  BOOTH_IMAGES_PAGE: 'bip',
  BOOTH_IMAGES_PAGE_SIZE: 'bips',
  BOOTH_VIDEOS_PAGE: 'bvp',
  BOOTH_VIDEOS_PAGE_SIZE: 'bvps',
  CUSTOMER_IMAGES_PAGE: 'cip',
  CUSTOMER_IMAGES_PAGE_SIZE: 'cips',
  CRITERIA_FEEDBACK_RANKING_PAGE: 'cfrp',
  CRITERIA_FEEDBACK_RANKING_PAGE_SIZE: 'cfrps',
  CRITERIA_FEEDBACK_QUESTION_PAGE: 'cfqp',
  CRITERIA_FEEDBACK_QUESTION_PAGE_SIZE: 'cfqps',
  MESSAGE_TYPE: 'mt',
  MEDIA_TYPE: 'met',
};

// Action IDs
export const ZMA_ACTION_ID = {
  PHOTO_ALBUM_SHARE_LINK: 'photoAlbumShareLink', // xử lý link photo album chia sẻ
  GET_LOYALTY_POINT: 'getLoyaltyPoint', // tích điểm thành viên
};

export const PAGINATION_CONST = {
  PAGE_DEFAULT: 0,
  PAGE_SIZE_DEFAULT: 20,
};

export const NoNeedPermissionRoute = [AppRouteConst.PAGE_403];
